/**
 * User roles enum - must match backend UserRole enum values
 */
export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  CLIENT = 'client',
  PREPARER = 'preparer',
}
